import { useCallback, useState, useEffect } from 'react';

import { Input, InputGroup, InputGroupText, DefaultTooltip } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

import ToggleGroup from './ToggleGroup';

export default function DimensionProperty({ name, label, prefix, options, icon }) {
  const { value, setValue } = useCraftProp(name)
  const [toggleValue, setToggleValue] = useState()

  useEffect(() => {
    if (!toggleValue) {
      const toggle = !value ? '' : !options.some(opt => opt.value === `${prefix}${value}`) ? 'fixed' : value
      setToggleValue(`${prefix}${toggle}`)
    }
  }, [options, prefix, value, toggleValue])

  const handleLayout = useCallback(newValue => {
    if (newValue === toggleValue) {
      setToggleValue(undefined)
      setValue(undefined)
      return
    }

    setToggleValue(newValue)
    if (newValue === `${prefix}fixed`) {
      setValue('')
    } else {
      const valueWithoutPrefix = newValue.replace(`${prefix}`, '')
      setValue(valueWithoutPrefix)
    }
  }, [setValue, toggleValue, prefix])

  const handleInputChange = useCallback(newValue => {
    setValue(newValue)
  }, [setValue])

  return <>
    <div className='flex gap-1'>
      <ToggleGroup
        name={name}
        options={options}
        type='single'
        className='flex-1'
        value={toggleValue}
        onValueChange={handleLayout}
      />
    </div>
    <div className='flex gap-1 mt-1'>
      {toggleValue === `${prefix}fixed` && <>
        <InputGroup variant='accent' className='w-full'>
          <DefaultTooltip content={label}>
            <InputGroupText addonType='prepend'>
              {icon}
            </InputGroupText>
          </DefaultTooltip>
          <Input
            type='text'
            value={value}
            onChange={evt => handleInputChange(evt.target.value)}
            onKeyDown={e => e.key === ',' && e.preventDefault()}
          />
        </InputGroup>
      </>}
    </div>
  </>
}
